<!-- Author ミィン -->
<!-- 雇用保険適用事業所設置届 -->

<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t('general.add')}}
        </el-button>
      </el-form-item>
    </el-form>

    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('empIns2.office_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns2.installation_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.installation_date }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns2.emp_ins_section_name')" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.emp_ins_section_name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns2.social_ins')" align="center">
        <el-table-column :label="$t('empIns2.social_ins_health_part')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.social_ins_health">〇</span>
            <span v-else>✖</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('empIns2.social_ins_pension_part')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.social_ins_pension">〇</span>
            <span v-else>✖</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('empIns2.social_ins_accident_part')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.social_ins_accident">〇</span>
            <span v-else>✖</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t('general.delete')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t('general.print')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- New -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="50%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition" style="margin-left:50px">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="24">
            <div>
              <el-form-item :label="$t('companyInfo.name')+':'" prop="name1">
                <el-select v-model="ruleForm.name1" style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                  :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                  <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('general.date')+':'" prop="date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.date" size="mini"
                  style="margin-left:10px;width: 185px" value-format="yyyy-MM-dd" type="date" placeholder="2020-02-10">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empIns2.installation_date')+':'" prop="installation_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.installation_date" size="mini"
                  style="margin-left:10px;width: 185px" value-format="yyyy-MM-dd" type="date" placeholder="2020-02-10">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empIns2.emp_ins_section_name')+':'" prop="emp_ins_section_name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.emp_ins_section_name" size="mini"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns2.social_ins')+':'">
                <el-form-item :label="$t('empIns2.social_ins_health_part')+':'" prop="social_ins_health"
                  label-width="100px;">
                  <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.social_ins_health" size="mini"
                    style="margin-left:10px;"></el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('empIns2.social_ins_pension_part')+':'" prop="social_ins_pension"
                  label-width="100px;">
                  <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.social_ins_pension" size="mini"
                    style="margin-left:10px;"></el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('empIns2.social_ins_accident_part')+':'" prop="social_ins_accident"
                  label-width="100px;">
                  <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.social_ins_accident" size="mini"
                    style="margin-left:10px;"></el-checkbox>
                </el-form-item>
              </el-form-item>

              <el-form-item :label="$t('empIns2.remark')+':'" prop="remark">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini"
                  style="margin-left:10px;width: 390px" placeholder></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="50%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition" style="margin-left:50px">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="24">
            <div>
              <el-form-item :label="$t('general.date')+':'" prop="date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.date" size="mini"
                  style="margin-left:10px;width: 185px" value-format="yyyy-MM-dd" type="date" placeholder="2020-02-10">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empIns2.installation_date')+':'" prop="installation_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.installation_date" size="mini"
                  style="margin-left:10px;width: 185px" value-format="yyyy-MM-dd" type="date" placeholder="2020-02-10">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empIns2.emp_ins_section_name')+':'" prop="emp_ins_section_name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.emp_ins_section_name" size="mini"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns2.social_ins')+':'">
                <el-form-item :label="$t('empIns2.social_ins_health_part')+':'" prop="social_ins_health"
                  label-width="100px;">
                  <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.social_ins_health" size="mini"
                    style="margin-left:10px;"></el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('empIns2.social_ins_pension_part')+':'" prop="social_ins_pension"
                  label-width="100px;">
                  <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.social_ins_pension" size="mini"
                    style="margin-left:10px;"></el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('empIns2.social_ins_accident_part')+':'" prop="social_ins_accident"
                  label-width="100px;">
                  <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.social_ins_accident" size="mini"
                    style="margin-left:10px;"></el-checkbox>
                </el-form-item>
              </el-form-item>

              <el-form-item :label="$t('empIns2.remark')+':'" prop="remark">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini"
                  style="margin-left:10px;width: 390px" placeholder></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        ruleForm: {
          id: "",
          remark: "",
          date: "",
          installation_date: "",
          emp_ins_section_name: "",
          social_ins_health: false,
          social_ins_pension: false,
          social_ins_accident: false,
          name1: ""
        },
        rules: {
          installation_date: [{
            required: true,
            message: this.$t("empIns2.enter_installation_date"),
            trigger: "blur"
          }],
          emp_ins_section_name: [{
            required: true,
            message: this.$t("empIns2.enter_name_in_charge"),
            trigger: "blur"
          }],
          name1: [{
            required: true,
            message: "入力してください",
            trigger: "blur",
          },],
          date: [{
            required: true,
            message: "入力してください",
            trigger: "blur",
          },],
        },
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
        companyInfo: []
      };
    },
    methods: {
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open(
          "/pdf/雇用保険適用事業所設置届-" + row.date + "-" + "uid=" + uid + ".pdf"
        );

      },

      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id
        });
        this.axios({
          method: "post",
          url: "/empIns2PDF",
          data: postData
        })
          .then(response => {
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 300);
          })
          .catch(error => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row); //这句是关键！！！
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row); //这句是关键！！！
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id
            });
            this.axios({
              method: "post",
              url: "/deleteEmpIns2",
              data: postData
            })
              .then(response => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageEmpIns2")
                  .then(response => {
                    this.tableData = response.data;
                  })
                  .catch(error => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed")
                });
              })
              .catch(error => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.print_failed"),
                });
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled")
            });
          });
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => { });
      },

      handleCurrentChange() {
        let postData = this.qs.stringify({
          page: this.currentPage
        });
        this.axios({
          method: "post",
          url: "/pageEmpIns2",
          data: postData
        })
          .then(response => {
            this.tableData = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          remark: "",
          date: "",
          installation_date: "",
          emp_ins_section_name: "",
          social_ins_health: false,
          social_ins_pension: false,
          social_ins_accident: false
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              remark: this.ruleForm.remark,
              date: this.ruleForm.date,
              installation_date: this.ruleForm.installation_date,
              emp_ins_section_name: this.ruleForm.emp_ins_section_name,
              social_ins_health: this.ruleForm.social_ins_health,
              social_ins_pension: this.ruleForm.social_ins_pension,
              social_ins_accident: this.ruleForm.social_ins_accident
            });
            this.axios({
              method: "post",
              url: "/insertEmpIns2",
              data: postData
            })
              .then(response => {
                this.axios
                  .post("/pageEmpIns2")
                  .then(response => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.cancel();
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed")
                    });
                  })
                  .catch(error => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed")
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
              })
              .catch(error => {
              });
          } else {
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              remark: this.ruleForm.remark,
              date: this.ruleForm.date,
              installation_date: this.ruleForm.installation_date,
              emp_ins_section_name: this.ruleForm.emp_ins_section_name,
              social_ins_health: this.ruleForm.social_ins_health,
              social_ins_pension: this.ruleForm.social_ins_pension,
              social_ins_accident: this.ruleForm.social_ins_accident
            });
            this.axios({
              method: "post",
              url: "/updateEmpIns2",
              data: postData
            })
              .then(response => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_failed")
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message.error("general.valid_failed");
            return false;
          }
        });
      },
      onSearch() {
        let postData = this.qs.stringify({
          name: this.search
        });
        this.axios({
          method: "post",
          url: "/ListByNameEmpIns2",
          data: postData
        })
          .then(response => {
            this.tableData = response.data;
            this.disablePage = true;
          })
          .catch(error => {
            console.log(error);
          });
      },
      getPages() {
        this.axios
          .post("/rowsEmpIns2")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      }
    },
    created() {
      this.axios
        .post("/pageEmpIns2")
        .then(response => {
          // this.show = true;
          // this.$message({
          //   type: 'error',
          //   message: '開発中です。'
          // });
          this.tableData = response.data;
        })
        .catch(error => {

          console.log(error);
        });

      this.axios
        .post("/rowsEmpIns2")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });

      this.axios
        .post("/ListComInfo")
        .then((response) => {
          // console.log(response.data);
          this.companyInfo = response.data;
          // console.log(this.companyInfo);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
</script>

<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .item1 {
    visibility: hidden;
  }

  .item2 {
    visibility: hidden;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns2.vue